import { SAvailableWrapper, SDot, SText } from './AvailableStatus.styled'

export const AvailableStatus = ({ text }: { text: string }) => (
  <SAvailableWrapper>
    <SDot />
    <SText variant="bodyBold">{text}</SText>
  </SAvailableWrapper>
)
